import { ArrowRight } from "lucide-react";
import { trackEvent } from "@/lib/tracking";

export const ACCENT = "#E8562A";
export const INK = "#16120F";

export const SERVICE_OPTIONS = {
  store: "eCommerce Website Development",
  strategy: "eCommerce Strategy & Growth",
  marketplace: "Marketplace Enablement",
};

// Remember which service a CTA was for, so the enquiry form (Phase 5) can preselect it.
export function goToForm(serviceKey, location) {
  if (serviceKey) {
    try { sessionStorage.setItem("rekisa_ecom_service", SERVICE_OPTIONS[serviceKey]); } catch (_) { /* ignore */ }
    window.dispatchEvent(new CustomEvent("rekisa:ecom-service", { detail: SERVICE_OPTIONS[serviceKey] }));
  }
  window.__rekisaHeadingToForm = true;
  trackEvent("cta_click", { location, service: "ecommerce_solutions", service_interest: serviceKey || "general" });
}

export const Eyebrow = ({ children, dark = false }) => (
  <div className={`inline-flex items-center gap-2 rounded-full border px-3.5 py-1.5 text-[11px] tracking-[0.14em] uppercase font-semibold mb-6 ${dark ? "border-white/15 bg-white/[0.06] text-white/75" : "border-zinc-200 bg-white text-zinc-600"}`}>
    <span className="h-1.5 w-1.5 rounded-full" style={{ background: ACCENT }} /> {children}
  </div>
);

export const H2 = ({ id, children, dark = false, className = "" }) => (
  <h2 id={id} className={`font-display text-4xl sm:text-5xl lg:text-[54px] font-black tracking-[-0.03em] leading-[1.04] ${dark ? "text-white" : "text-zinc-900"} ${className}`}>
    {children}
  </h2>
);

export function CtaLink({ label, serviceKey, location, testid, variant = "primary" }) {
  const styles = {
    primary: "text-white shadow-[0_10px_28px_-10px_rgba(232,86,42,0.7)] hover:brightness-110",
    dark: "bg-[#16120F] text-white hover:bg-black",
    light: "bg-white text-zinc-900 hover:bg-zinc-100",
  };
  return (
    <a
      href="#request-quote"
      onClick={() => goToForm(serviceKey, location)}
      data-testid={testid}
      className={`inline-flex items-center justify-center gap-1.5 rounded-full min-h-12 px-6 py-3 text-center text-base font-bold transition-[filter,background-color] ${styles[variant]}`}
      style={variant === "primary" ? { background: ACCENT } : undefined}
    >
      {label} <ArrowRight className="h-5 w-5 shrink-0" />
    </a>
  );
}

export const MARKETPLACES = [
  { name: "Amazon", src: "/media/logos/amazon.svg", h: "h-7 sm:h-8" },
  { name: "Takealot", src: "/media/logos/takealot.svg", h: "h-6 sm:h-7" },
  { name: "Makro", src: "/media/logos/makro.png", h: "h-6 sm:h-7" },
];

export function MarketplaceLogos({ testid, compact = false }) {
  return (
    <div data-testid={testid}>
      <ul className={`flex flex-wrap items-center justify-center ${compact ? "gap-3" : "gap-x-8 gap-y-5"}`}>
        {MARKETPLACES.map((m) => (
          <li key={m.name} className="flex items-center justify-center rounded-2xl bg-white px-4 py-3.5 border border-zinc-200 min-w-[116px]">
            <img src={m.src} alt={`${m.name} logo`} className={`${m.h} w-auto object-contain`} loading="lazy" decoding="async" width="120" height="36" />
          </li>
        ))}
      </ul>
      <p className="mt-4 text-center text-xs leading-relaxed text-zinc-600 max-w-xl mx-auto">
        Marketplace names and logos are trademarks of their respective owners. Seller approval is determined by each marketplace.
      </p>
    </div>
  );
}
